import { lazy, Suspense } from 'react';
import {
  Navigate,
  type LoaderFunctionArgs,
  type RouteObject,
} from 'react-router-dom';
import * as loaders from '../loader';
import { isMobile } from '../utils';
import { vchartRoutes } from './vchart';
import { vtableRoutes } from './vtable';
import { vgrammarRoutes } from './vgrammar';
import { vrenderRoutes } from './vrender';
import { VMindRoutes } from './vmind';
import { vstoryRoutes } from './vstory';
import { vgraphRoutes } from './vgraph';

const VisActor = lazy(() => import('../sites/visactor'));

const Blog = lazy(async () => {
  const { Blog } = await import('../sites/visactor/views/blog');
  return { default: Blog };
});

const Senario = lazy(async () => {
  const { Senario } = await import('../sites/visactor/views/senario');
  return { default: Senario };
});

const ChartAssistant = lazy(async () => {
  const { ChartAssistant } = await import(
    '../sites/visactor/views/chart-assistant'
  );
  return { default: ChartAssistant };
});

export const routes: RouteObject[] = [
  {
    path: '/',
    async loader({ request }: LoaderFunctionArgs) {
      return {
        isMobile: isMobile(request.headers.get('User-Agent') ?? ''),
        // isMobile: true,
      };
    },
    element: (
      <Suspense>
        <VisActor />
      </Suspense>
    ),
  },
  {
    path: '/blog',
    loader: loaders.blogLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <Blog />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        loader: loaders.blogLoader,
        element: (
          <Suspense>
            <Blog />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/senario',
    // loader: loaders.blogLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <Senario />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        // loader: loaders.blogLoader,
        element: (
          <Suspense>
            <Senario />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/chart-assistant',
    element: (
      <Suspense>
        <ChartAssistant />
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <ChartAssistant />
          </Suspense>
        ),
      },
    ],
  },
  ...vchartRoutes,
  ...vtableRoutes,
  ...vgrammarRoutes,
  ...vrenderRoutes,
  ...VMindRoutes,
  ...vstoryRoutes,
  ...vgraphRoutes,
  {
    path: '*',
    element: <Navigate to="/" />,
  },
];
